import React from 'react';

const Monitoring: React.FC = () => {
  return (
    <div className="max-w-[1400px] mx-auto px-6">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Monitoring</h1>
      <p className="text-gray-600 dark:text-gray-400">Coming soon...</p>
    </div>
  );
};

export default Monitoring;